import * as React from "react";
import {
  Box,
  Button,
  Collapse,
  makeStyles,
  ThemeProvider,
} from "@material-ui/core";
import {SvgIcon} from "../../../../components";
import {base64toFile, tl} from "../../../../utils";
import {MUIDialog, Theme as theme} from "..";
import * as ReactDOM from "react-dom";
import api from "../../../../api";

import "react-advanced-cropper/dist/style.css";
import { CropperDialog } from "./dialog";

const usePreviewStyles = makeStyles((theme) => ({
  achieveUploader: {
    width: 300,
    height: 169,
  },
  oldUploader: {
    width: 160,
    height: 160,
  },
  videoPreview: {
    width: 400,
    height: 320,
  },
  lessonCaption: {
    width: 366,
    height: 178,
  },
  lessonCaptionMobile: {
    width: 197,
    height: 95,
  }
}));


const errorDict: {[key: string]: string} = {
  "fileSize": tl("Файл слишком большого размера"), 
  "load": tl("Изображение слишком маленького размера"), 
  "tooSmall": tl("Не удалось загрузить изображение, попробуйте позже"),
}

interface BannerCropperProps {
  className?: keyof ReturnType<typeof usePreviewStyles> | string;
  onCropSave: (link: string) => void;
  onLoadEnd?: (link: string) => void;
  banner?: string;
  aspect?: number;
  cropDialogMaxWidth?: "xs" | "sm" | "md" | "lg" | "xl";
  minWidth?: number;
  minHeight?: number;
  maxSize?: number;
  accept?: string;
  onDelete?: () => void;
  onError?: (err: string) => void;
  /**
   * @param placeholderComponent компонент когда нет изображения
   */
  placeholderComponent?: React.ReactNode,
  children?: React.ReactElement<{onClick: () => void, hui: string}>
  courseId?: string | number;
  groupId?: string | number;
  fileId?: string | number;
  useSystem?: false;

}

export const BannerCropper: React.FC<BannerCropperProps> = ({
  onCropSave,
  banner,
  accept,
  aspect,
  className,
  cropDialogMaxWidth,
  minHeight,
  minWidth,
  maxSize,
  onDelete,
  onError,
  children,
  placeholderComponent,
  courseId,
  groupId,
  fileId,
  useSystem,
}) => {
  const classes = useStyles();
  const preveiewStyles = usePreviewStyles();
  const [upImg, setUpImg] = React.useState<string | null | undefined>(null);
  const [currentBanner, setCurrentBanner] = React.useState<string>(banner);
  const [file, setFile] = React.useState<File | undefined>();
  const [error, setError] = React.useState<
    "fileSize" | "load" | "tooSmall" | undefined
  >();
  const [loading, setLoading] = React.useState(false);
  const inputRef = React.useRef<HTMLInputElement>(null);

  //хак для смарти встраивания, гарантировано обновляет текущее изображение из пропс, потом можно будет удалить
  React.useEffect(() => {
    setCurrentBanner(banner);
  }, [banner])

  const onSelectFile = async (e: React.ChangeEvent<HTMLInputElement>) => {
    setError(undefined);
    onError && onError(undefined);
    const target = e.currentTarget;
    if (target && target.files && target.files.length > 0) {
      const file = target.files[0];
      if (maxSize && file.size > maxSize) {
        setError("fileSize");
        onError && onError(errorDict["fileSize"]);
        return;
      }
      const base64 = URL.createObjectURL(file);
      const image = new Image();
      image.src = base64;
      image.onload = function() {
        //@ts-ignore
        const {width, height}: {[key: string]: number} = this;
        if (
          (minWidth && width < minWidth) ||
          (minHeight && height < minHeight)
        ) {
          setError("tooSmall");
          onError && onError(errorDict["tooSmall"]);
        } else {
          setFile(file);
          setUpImg(base64);
        }
      };
    }
  };



  const handleInputClick = () => {
    inputRef.current?.click();
  };
  const uploadImage = async (imageFile: File) => {
    setLoading(true);
    setError(undefined);
    setUpImg(undefined);
    try {
      const newFile = await api.file.upload(imageFile, null, {
        course_id: courseId,
        group_id: groupId,
        file_id: fileId,
        useSystem: useSystem,
      });
      setCurrentBanner(newFile.resultLink);
      onCropSave && onCropSave(newFile.resultLink);
      setLoading(false);
    } catch (error) {
      setError('load');
      onError && onError(errorDict["tooSmall"]);
    }
  }

  const handleDialogCancel = () => {
    setUpImg(null);
    inputRef.current!.value = "";
  }

  return (
    <>
      <input
        accept={accept}
        className={classes.hiddenInput}
        onChange={onSelectFile}
        type="file"
        name="banner"
        ref={inputRef}
      />
      {children ? 
        React.cloneElement(React.Children.only(children),{
          ...children.props,
          onClick: () => !banner ? handleInputClick() : onDelete(),
          onDelete: () => onDelete(),
          error: errorDict[error],
          loading: loading,
        })
       : 
        <div className={classes.root}>
            <Button
              onClick={currentBanner ? undefined : handleInputClick}
              variant="contained"
              style={{display: 'flex', alignItems: 'center', justifyContent: 'center'}}
              //@ts-ignore
              className={`MuiButton-cover ${classes.preview} ${className in  preveiewStyles  ? preveiewStyles[className] : className}`}
            >
              <Box className={classes.cover}>
              {currentBanner ?  
                <img
                  alt="ico"
                  src={currentBanner}
                  onLoadStart={() => setLoading(true)}
                  onLoad={() => setLoading(false)}
                  className={classes.image}
                  //@ts-ignore
                /> : placeholderComponent ? placeholderComponent() : 
                  <Box
                    bgcolor={theme.palette.background.paper}
                    className={classes.plus}
                  >
                    <SvgIcon type="fs-attach" />
                  </Box>
              }
              {currentBanner && !loading &&
                <Box className={classes.refresh}>
                  <Box className={classes.iconWrap} onClick={handleInputClick}>
                    <SvgIcon type="courses-renew" />
                  </Box>
                  {onDelete && (
                    <Box className={classes.iconWrap} onClick={onDelete}>
                      <SvgIcon type="delete-bin" />
                    </Box>
                  )}
                </Box>}
              {loading &&
                <Box className={classes.loader}>
                  <Box className="bg" />
                  <Box className="loader-icon" onClick={handleInputClick}>
                    <SvgIcon type="courses-renew" />
                  </Box>
                </Box>}
            </Box>
            <Collapse in={Boolean(error)}>
              <Box className={classes.errorNotification}>
                {errorDict[error]}
              </Box>
            </Collapse>
          </Button>
        </div>
       }
        <CropperDialog 
          image={upImg} 
          file={file} 
          onCancel={handleDialogCancel} 
          onConfirm={uploadImage} 
          aspect={aspect}
          minHeight={minHeight}
          minWidth={minWidth}
        />
      </>
      //  <div className={classes.root}>
      //     {!currentBanner ? (
      //       <Button
      //         variant="contained"
      //         onClick={handleInputClick}
      //         //@ts-ignore
      //         className={`MuiButton-cover ${classes.preview} ${className in  preveiewStyles  ? preveiewStyles[className] : className}`}
      //       >
      //         <Box
      //           bgcolor={theme.palette.background.paper}
      //           className={classes.plus}
      //         >
      //           <SvgIcon type="fs-attach" />
      //         </Box>
      //         <Collapse in={Boolean(error)}>
      //             <Box className={classes.errorNotification}>
      //               {error === "fileSize" && tl("Файл слишком большого размера")}
      //               {error === "tooSmall" &&
      //                 tl("Изображение слишком маленького размера")}
      //               {error === "load" &&
      //                 tl("Не удалось загрузить изображение, попробуйте позже")}
      //             </Box>
      //           </Collapse>
      //       </Button>
      //     ) : (
      //       <Box
      //         display="flex"
      //         position="relative"
      //         //@ts-ignore
      //         className={`${classes.preview} ${className in  preveiewStyles  ? preveiewStyles[className] : className}`}
      //       >
      //         <Box className={classes.cover}>
      //           <img
      //             alt="ico"
      //             src={currentBanner}
      //             onLoadStart={() => setLoading(true)}
      //             onLoad={() => setLoading(false)}
      //             className={classes.image}
      //           /> 
      //         </Box>
      //       </Box>
      //     )}
      //     <Box
      //       display="flex"
      //       position="absolute"
      //       top={0}
      //       left={0}
      //       onClick={handleInputClick}
      //       //@ts-ignore
      //       className={`${classes.preview} ${className in  preveiewStyles  ? preveiewStyles[className] : className}`}
      //     >
      //     {!loading ? currentBanner ?
      //      ( <Box className={classes.refresh}>
      //       <Box className={classes.iconWrap} onClick={handleInputClick}>
      //         <SvgIcon type="courses-renew" />
      //       </Box>
      //       {onDelete && (
      //         <Box className={classes.iconWrap} onClick={onDelete}>
      //           <SvgIcon type="delete-bin" />
      //         </Box>
      //       )}
      //     </Box>)
      //     : null : (
      //         <Box className={classes.loader}>
      //           <Box className="bg" />
      //           <Box className="loader-icon" onClick={handleInputClick}>
      //             <SvgIcon type="courses-renew" />
      //             {tl("Загружается...")}
      //           </Box>
      //         </Box>
      //       )}
      //       <Collapse in={Boolean(error)}>
      //         <Box className={classes.errorNotification}>
      //           {errorDict[error]}
      //         </Box>
      //       </Collapse>
      //       </Box>
      //     </div>
      // }
   
  );
};

const useStyles = makeStyles((theme) => ({
  "@global": {
    "@keyframes spin": {
      "100%": {
        transform: "rotate(360deg)",
      },
    },
  },
  root: {
    position: 'relative',
    overflow: 'hidden',
    '&:hover $image': {
      opacity: .5
    }
  },
  refresh: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    margin: "auto",
    position: "absolute",
    cursor: "default",
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    zIndex: 3,
    [theme.breakpoints.down('md')]: {
      '& $iconWrap': {
        transform: "translateY(0)",
      }
    },
    '& $iconWrap': {
      transform: "translateY(500px)",
    },
    '&:hover': {
      
      '& $iconWrap': {
        transform: "translateY(0)",
      }
    }
  },
  iconWrap: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    background: theme.palette.grey.A700,
    width: 35,
    height: 35,
    borderRadius: "50%",
    margin: "0 4px",
    transition: 'transform 0.2s ease-out',
    cursor: 'pointer'
  },
  preview: {
    borderRadius: 4,
    overflow: "hidden",
  },

  hiddenInput: {
    position: "absolute",
    top: -10000,
  },
  plus: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    width: 26,
    height: 26,
    margin: "auto",
    borderRadius: "50%",
  },
  errorNotification: {
    position: "absolute",
    top: 0,
    left: 0,
    right: 0,
    padding: "4px 5px",
    fontSize: 13,
    lineHeight: "15px",
    borderStyle: "solid",
    borderWidth: 2,
    borderColor: theme.palette.info.dark,
    backgroundColor: theme.palette.info.light,
    color: theme.palette.info.contrastText,
    borderRadius: 4,
    margin: 4,
  },
  loader: {
    width: "100%",
    height: "100%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    position: "absolute",
    top: 0,
    left: 0,
    "& .loader-icon": {
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      background: theme.palette.grey.A700,
      fontWeight: 500,
      color: theme.palette.primary.dark,
      height: 35,
      padding: "0 8px",
      cursor: "pointer",
      borderRadius: 17,
      zIndex: 4,
      "& .svgicon": {
        animation: "$spin 4s linear infinite",
      },
    },
    "& .bg": {
      position: "absolute",
      top: 0,
      right: 0,
      bottom: 0,
      left: 0,
      borderRadius: 4,
      opacity: 0.2,
      zIndex: 3,
      backgroundColor: theme.palette.primary.light,
    },
  },

  cover: {
    borderRadius: 4,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    height: '100%',
  },
  image: {
    maxHeight: "100%",
    maxWidth: "100%",
    transition: "opacity 0.2s",
  }

}));

(window as any).react_render_cropper = (nodeId: string, data: any) => {
  ReactDOM.render(
    <ThemeProvider theme={theme}>
      <BannerCropper {...data} />
    </ThemeProvider>,
    document.getElementById(nodeId)
  );
};
